import * as React from 'react';
import classnames from 'classnames';
import { Select } from '@grandvisionhq/forms';
import { H3 } from '@grandvisionhq/iris-ui';
import { useIntl } from '@grandvisionhq/state';
import '@grandvisionhq/analytics';
import '../../../../context/actions.js';
import '../../../../context/reducer.js';
import '../../../../types/product.js';
import '../../../../context/ProductContext.js';
import '../../../../context/CmsContext.js';
import '@swc/helpers';
import { pushDeliveryIntervalSelectionEvent } from '../../../Analytics/events/subscription-events.js';
import '@grandvisionhq/svc-tealium/events';
import '@grandvisionhq/utils';
import '@grandvisionhq/graphql';
import '@grandvisionhq/svc-tealium/utils';

const DeliveryIntervalSelect = /*#__PURE__*/ React.memo(({ className , hasError , singleOptionLabel , deliveryIntervalOptions , selectedInterval , onIntervalSelection  })=>{
    const { getLabel  } = useIntl();
    const title = getLabel('products.subscriptions.deliveryInterval.title');
    const handleIntervalSelection = React.useCallback((interval)=>{
        pushDeliveryIntervalSelectionEvent(interval);
        onIntervalSelection(interval);
    }, []);
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames('delivery-interval-select', className)
    }, /*#__PURE__*/ React.createElement(H3, {
        className: "delivery-interval-select__title",
        variant: "heading-smallest"
    }, title), singleOptionLabel ? /*#__PURE__*/ React.createElement(React.Fragment, null, singleOptionLabel) : /*#__PURE__*/ React.createElement(Select, {
        className: "delivery-interval-select__select",
        placeholder: getLabel('products.subscriptions.deliveryInterval.placeholder'),
        id: "delivery_interval_select",
        name: "delivery_interval_select",
        options: deliveryIntervalOptions,
        initialState: selectedInterval,
        onChange: handleIntervalSelection,
        "aria-invalid": hasError,
        "aria-label": title,
        required: true,
        "data-t": "delivery-interval-select"
    }));
});

export { DeliveryIntervalSelect };
//# sourceMappingURL=DeliveryIntervalSelect.js.map
